
import { Component, Mixins } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules/index";
import mixin from "./mixin";
import * as modals from "../../../lib/modals";
import { formatDateWithTime, formatDate } from "../../../utils";
import notifications from "../../../lib/notifications";

const orderModule = getModule(OrderModule);

@Component({
  name: modals.deliveryDateHistoryLogsModal
})
export default class DeliveryDateHistoryLogsModal extends Mixins(mixin) {
  deliveryHistoryLogs: any = null;
  loading: boolean = false;
  sortDateDesc: boolean = false;

  get orderNumber() {
    return this.selectedItems[0].number;
  }

  formatDate(date) {
    return formatDate(date, "MM/DD/yyyy hh:mm:ss A");
  }

  formatString2Date(dateString: String) {
    if (!dateString || dateString.length < 10) return dateString;
    else {
      return dateString.substring(0, 10);
    }
  }

  toggleSort() {
    this.sortDateDesc = !this.sortDateDesc;
    this.deliveryHistoryLogs = this.deliveryHistoryLogs.sort((a, b) =>
      this.sortDateDesc
        ? new Date(b.logDate).getTime() - new Date(a.logDate).getTime()
        : new Date(a.logDate).getTime() - new Date(b.logDate).getTime()
    );
  }

  async load() {
    this.show();
    this.loading = true;
    this.deliveryHistoryLogs = null;
    try {
      const response = await orderModule.getOrderDeliveryHistoryLog(this.orderNumber);
      this.deliveryHistoryLogs = response.data;
    } catch (ex) {
      notifications.error("Vision Ops Logs", "Failed to load Vision Ops logs for order.", ex);
    }
    this.loading = false;
  }
}
